import { motion } from "framer-motion";
import { Eye, Heart, Sparkles, ClipboardCheck } from "lucide-react";

const highlights = [
  { icon: Eye, label: "Monitoring berkala" },
  { icon: Heart, label: "Perawatan intensif" },
  { icon: Sparkles, label: "Kebersihan terjaga" },
  { icon: ClipboardCheck, label: "Observasi kondisi pasien" },
];
const ease = [0.2, 0.8, 0.2, 1];

export default function RawatInap() {
  return (
    <section
      id="rawat-inap"
      data-testid="rawat-inap-section"
      className="relative py-24 md:py-32 bg-[var(--pikko-cream)]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5">
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="eyebrow"
          >
            — 02 / Layanan
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.85, ease }}
            className="mt-4 font-serif text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] tracking-tight text-[var(--pikko-brown-ink)]"
          >
            <span className="italic text-[var(--pikko-orange)]">Rawat</span> Inap
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.85, delay: 0.1, ease }}
            className="mt-6 text-[15px] leading-relaxed text-[var(--pikko-brown-deep)]/85 max-w-xl"
          >
            Fasilitas rawat inap dengan observasi berkala untuk mendukung proses
            pemulihan dan kenyamanan pasien selama masa perawatan.
          </motion.p>

          <div className="mt-9 space-y-3">
            {highlights.map((h, i) => (
              <motion.div
                key={h.label}
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.15 + i * 0.08, ease }}
                data-testid={`rawat-inap-highlight-${i}`}
                className="flex items-center gap-4 group"
              >
                <div className="w-10 h-10 rounded-full bg-[var(--pikko-cream-warm)] border border-[rgba(138,107,82,0.18)] flex items-center justify-center group-hover:bg-[var(--pikko-orange)]/12 group-hover:border-[var(--pikko-orange)]/40 transition-all duration-300">
                  <h.icon className="w-4 h-4 text-[var(--pikko-orange-dark)]" />
                </div>
                <div className="text-[15px] text-[var(--pikko-brown-deep)] font-medium">
                  {h.label}
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Image collage */}
        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease }}
          className="lg:col-span-7 grid grid-cols-12 grid-rows-6 gap-3 sm:gap-4 h-[460px] sm:h-[540px] lg:h-[600px]"
        >
          <div className="col-span-8 row-span-4 rounded-[28px] overflow-hidden shadow-[0_40px_100px_-50px_rgba(46,34,24,0.4)] border border-[rgba(138,107,82,0.15)]">
            <img
              src="/images/inpatient1.webp"
              alt="Fasilitas rawat inap stainless di Pikko Pet Care"
              className="w-full h-full object-cover warm-grade-strong"
              loading="lazy"
            />
          </div>
          <div className="col-span-4 row-span-3 rounded-[28px] overflow-hidden border border-[rgba(138,107,82,0.15)] shadow-[0_30px_70px_-40px_rgba(46,34,24,0.35)]">
            <img
              src="/images/inpatient2.webp"
              alt="Kandang observasi kucing"
              className="w-full h-full object-cover warm-grade-strong"
              loading="lazy"
            />
          </div>
          <div className="col-span-4 row-span-3 rounded-[28px] overflow-hidden border border-[rgba(138,107,82,0.15)] shadow-[0_30px_70px_-40px_rgba(46,34,24,0.35)]">
            <img
              src="/images/pethotel.webp"
              alt="Ruang inap dengan AC untuk hewan kesayangan"
              className="w-full h-full object-cover warm-grade-strong"
              loading="lazy"
            />
          </div>
          <div className="col-span-8 row-span-2 rounded-[28px] overflow-hidden glass-cream flex items-center px-7">
            <div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-[var(--pikko-orange-dark)] font-semibold">
                Pet Hotel & Boarding
              </div>
              <div className="mt-1.5 font-serif text-[20px] sm:text-[24px] text-[var(--pikko-brown-ink)] leading-snug">
                Ruang ber-AC, bersih, &amp; selalu termonitor
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
